module.exports = function () {
  return new Worker(__webpack_public_path__ + "8e7179476785bdfe2d05.worker.js");
};